<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="selected" :class="['join-values', {'not-selected' : !activeSelected}]">
        <div v-if="index > 0" :class="['join-button', 'and', {'selected': element.joinValue === 'and'}]" @click="changeGroupJoinValue('and', index)">{{ getLang('and') }}</div>
        <div v-if="index > 0" :class="['join-button', 'or', {'selected': element.joinValue === 'or'}]" @click="changeGroupJoinValue('or', index)">{{ getLang('or') }}</div>
        <div :class="['join-button', 'minus', {'selected': element.joinValue === 'minus'}]" @click="changeGroupJoinValue('minus', index)">{{ getLang('minus') }}</div>
      </div>
    </transition>
    <div :class="['group-item', {'with-join-values': selected && index > -1}]">
      <i class="sherpa-icon icon-copy item-icon"></i>
      <div class="question-description">
        <input type="text" v-model="element.name" :placeholder="getLang('conditionsGroupName')" class="name-input" @focus="disabledDraggable = true" @blur="disabledDraggable = false" />
      </div>
      <!-- Indicador de lista vacía -->
      <transition-group name="fade">
        <div key="empty-children" v-if="!element.children || element.children.length === 0 && !draggingElement"
          class="empty-list-indicator"
        >
          <span class="description">{{ getLang('dropItemsHere') }}</span>
          <!-- <i class="sherpa-icon icon-derecha"></i> -->
        </div>
        <template v-else>
          <div key="children-group" :class="['children', {'children-open' : childrenOpen}]">
            <i class="fas fa-chevron-circle-down fa-sm toggle-group-children" key="toggle-group-children" @click="childrenOpen = !childrenOpen"></i>
            <draggable
              v-show="childrenOpen"
              :key="element.id + '_children'"
              :class="['list-group', 'group-draggable', {'dragging-element' : draggingElement},
                {'selected-elements' : element.children && element.children.length > 0},
                {'empty-elements' : !element.children || element.children.length == 0}
              ]"
              v-model="element.children"
              item-key="id"
              v-bind="dragSelectedOptions"
              :disabled="disabledDraggable"
              @start="dragSelectedElementStart"
              @end="dragSelectedElementEnd"
              @add="elementAdded"
              @change="elementChanged"
            >
              <template #item="{ element: child, index }">
                <div
                  :ref="'item-' + child.id"
                  :key="child.id"
                  :class="['list-group-item', child.type, {'with-children': element.children && element.children.length > 0}]"
                >
                  <group-item v-if="child.type === 'group'"
                    :key="'group_' + child.id"
                    :element="child"
                    :parent="element"
                    :parentChildren="element.children"
                    :getTypeName="getTypeName"
                    :getLang="getLang"
                    :dragAllElement="dragAllElement"
                    :dragSelectedElementQuestion="dragSelectedElementQuestion"
                    :dragSelectedElementGroupId="dragSelectedElementGroupId"
                    :parentGroupIds="[...parentGroupIds, element.id]"
                    :dragSelectedExternalElementGroup="isExternalGroupDragged(child)"
                    :dragSelectedOptions="dragSelectedOptions"
                    :selected="selected"
                    :deleteElementFromList="deleteElementFromList"
                    :currentLanguage="currentLanguage"
                    :formBuilderContainer="formBuilderContainer"
                    :getElementFromSelectedList="getElementFromSelectedList"
                    :index="index"
                    :domainEndpoint="domainEndpoint"
                    :segmentId="segmentId"
                    :getRowsNumber="getRowsNumber"
                    :formatNumber="formatNumber"
                    :changeJoinValue="changeJoinValue"
                    @dragSelectedElementStart="dragSelectedChildElementStart"
                    @dragSelectedElementEnd="dragSelectedChildElementEnd"
                    @deleteElementCall="deleteChildElement"
                    @newRowsCount="rowsCount"
                    @newJoinValue="rowsCount"
                    @propagateActive="propagateActive"
                    @propagateInactive="rowsCount"
                  />
                  <question-item v-else-if="child.type === 'question' || child.type === 'indicator'"
                    :key="'question_' + child.id"
                    :element="child"
                    :parent="element"
                    :parentChildren="element.children"
                    :getTypeName="getTypeName"
                    :getLang="getLang"
                    :selected="selected"
                    :index="index"
                    :domainEndpoint="domainEndpoint"
                    :currentLanguage="currentLanguage"
                    :segmentId="segmentId"
                    :getRowsNumber="getRowsNumber"
                    :formatNumber="formatNumber"
                    :changeJoinValue="changeJoinValue"
                    @deleteElementCall="deleteChildElement"
                    @newRowsCount="rowsCount"
                    @newJoinValue="rowsCount"
                    @propagateActive="propagateActive"
                    @propagateInactive="rowsCount"
                  />
                </div>
              </template>
            </draggable>
          </div>
        </template>
      </transition-group>
      <template v-if="selected">
        <div class="edition-element">
          <transition name="fade-slide-right" mode="out-in">
            <div v-if="selected && element.active && element.children && element.children.some(child => child.active) && totalRows !== null" class="total-rows">
              <span class="total-label" key="total-label"><i :class="['fas', 'fa-sort-numeric-down', {'loading': totalRowsLoading}]"></i> {{ getLang('totalGroupRows') }}</span>
              <transition name="fade-slide-left" mode="out-in">
                <span v-if="!totalRowsLoading" class="total" key="total">{{ formatNumber(totalRows) }}</span>
                <spinner-loading class="spinner-loading" v-else :line-size='2' line-fg-color='#5dbecd' key="total-loading" />
              </transition>
            </div>
          </transition>
          <toggle-button
            v-model="element.active"
            :sync="true"
            :labels="{checked: getLang('active'), unchecked: getLang('inactive')}"
            :width="78"
            :font-size="11"
            :margin="2"
            :speed="200"
            :color="{checked: '#4ab800c5', unchecked: '#cfcfcf', disabled: '#efefef'}"
            @change="activeChange"
          />
          <i class="sherpa-icon icon-trash" @click="deleteElementCall"></i>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import groupItem from './groupItem'
import questionItem from './questionItem'
import ToggleButton from '@/components/shared/ToggleButton.vue'

export default {
  name: 'group-item',
  components: {
    draggable,
    groupItem,
    questionItem,
    ToggleButton
  },
  props: {
    element: Object,
    parent: Object,
    parentChildren: Array,
    getTypeName: Function,
    getLang: Function,
    deleteElementFromList: Function,
    dragAllElement: Boolean,
    dragSelectedElementQuestion: Boolean,
    dragSelectedElementGroupId: String,
    parentGroupIds: Array,
    dragSelectedExternalElementGroup: Boolean,
    dragSelectedOptions: Object,
    selected: Boolean,
    currentLanguage: String,
    formBuilderContainer: HTMLElement,
    formId: String,
    getElementFromSelectedList: Function,
    index: Number,
    domainEndpoint: String,
    segmentId: String,
    getRowsNumber: Function,
    formatNumber: Function,
    changeJoinValue: Function
  },
  data () {
    return {
      dragSelectedElementGroup: false,
      disabledDraggable: false,
      totalRowsLoading: false,
      totalRows: null,
      childrenOpen: true
    }
  },
  methods: {
    dragSelectedElementStart (event) {
      if (this.element.children[event.oldIndex].type === 'group') {
        this.dragSelectedElementGroup = true
      }
      this.$emit('dragSelectedElementStart', this.element.children[event.oldIndex], event)
    },
    dragSelectedElementEnd (event) {
      this.dragSelectedElementGroup = false
      this.$emit('dragSelectedElementEnd', this.element.children[event.newIndex])
    },
    dragSelectedChildElementStart (element, event) {
      this.$emit('dragSelectedElementStart', element, event)
      if (element.type === 'group') {
        this.dragSelectedElementGroup = true
      }
    },
    dragSelectedChildElementEnd (element) {
      this.dragSelectedElementGroup = false
      this.$emit('dragSelectedElementEnd', element)
    },
    deleteElementCall () {
      this.$emit('deleteElementCall', this.element)
    },
    deleteChildElement (childElement) {
      this.deleteElementFromList(childElement, this.element.children)
    },
    isExternalGroupDragged (child) {
      return this.dragSelectedElementGroupId != null && this.dragSelectedElementGroupId !== this.element.id && this.dragSelectedElementGroupId !== child.id && !this.parentGroupIds.includes(this.dragSelectedElementGroupId)
    },
    elementAdded (event) {
    },
    elementChanged (event) {
    },
    rowsCount () {
      if (this.element.children && this.element.children.some(child => child.active)) {
        this.getRowsNumber(this.element.children, this)
        this.$emit('newRowsCount')
      } else {
        this.totalRowsLoading = false
        this.totalRows = null
      }
    },
    changeGroupJoinValue (value, index) {
      if (this.element.active) {
        this.changeJoinValue(this, value, index)
      }
    },
    activeChange (toggle) {
      if (toggle.value === false) {
        this.totalRowsLoading = false
        this.totalRows = null
        this.propagateInactive(this.element.children)
        this.$emit('propagateInactive', this.element)
      } else {
        this.$emit('propagateActive', this.element)
      }
    },
    propagateInactive (elements) {
      if (elements) {
        elements.forEach((element) => {
          element.active = false
          this.propagateInactive(element.children)
        })
      }
    },
    propagateActive () {
      if (!this.element.active) {
        this.element.active = true
        this.$emit('propagateActive', this.element)
      }
    }
  },
  mounted () {
  },
  computed: {
    activeSelected () {
      return this.selected && this.element.active
    },
    draggingElement () {
      return this.dragAllElement || this.dragSelectedElementQuestion || this.dragSelectedExternalElementGroup
    },
    elementJoinValueFingerprint () {
      return JSON.stringify(this.element.joinValue)
    }
  },
  watch: {
    elementJoinValueFingerprint () {
      this.$emit('newJoinValue')
    }
  }
}
</script>

<style lang="scss" scoped>
.group-item {
  transition: all 0.2s ease;
  position: relative;

  &.with-join-values {
    padding-top: 35px;

    .question-description {
      padding-right: 3px;
    }
  }

  .total-rows {
    height: 26px;
    padding: 5px 7px;
    display: inline-flex;
    align-items: center;
    border-radius: 3px;
    border: 1px solid #269809;
    transition: all 0.2s ease;
    background-color: #ecffe6;
    transition: all 0.2s ease;
    margin-right: 10px;

    .total-label,
    .total {
      color: #269809;
      font-family: 'Source Sans Pro';
      font-size: 13px;
      display: inline-block;
    }

    .total-label {
      margin-right: 6px;

      i {
        font-size: 12px;
        margin-right: 1px;
        color: #269809;
        vertical-align: baseline !important;
        margin-left: 0;
        width: initial;

        &.loading {
          animation: blink 0.8s ease-in-out infinite;
        }
      }

      @keyframes blink {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
      }
    }

    .total {
      font-weight: 600;
      font-size: 15px;
      color: #269809;
    }

    .spinner-loading {
      display: inline-block;

      .vue-simple-spinner {
        width: 14px !important;
        height: 14px !important;
      }
    }
  }

  .question-description {
    vertical-align: top;

    .name-input {
      border: 1px solid transparent;
      outline: none;
      width: 100%;
      background-color: #ffffffc0;
      transition: all 0.2s ease;
      cursor: pointer;
      padding: 1px 5px 1px 5px;
      margin-left: 2px;
      font-size: 14px;
      color: #333;

      &:hover,
      &:focus {
        border: 1px solid #cdcdcd !important;
        outline: none;
        box-shadow: none;
        background-color: #ffffffcc;
      }

      &:focus {
        cursor: text;
        border: 1px solid #aaa !important;
      }

      &::placeholder {
        opacity: 0.6;
        font-style: italic;
        font-size: 13px;
      }
    }
  }

  .children {
    position: relative;

    .toggle-group-children {
      vertical-align: inherit !important;
      font-size: 17px;
      color: #076cfabe;
      transition: all 0.2s ease;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      top: -6px;
      z-index: 100;
      cursor: pointer;
      opacity: 1;

      &:hover {
        opacity: 1;
      }
    }

    &.children-open {
      .toggle-group-children {
        transform: scaleY(-1);
      }
    }
  }

  .group-draggable {
    position: relative;
    margin-top: 9px;
    padding: 5px 5px 10px 5px;
    overflow: visible;

    & > span {
      position: relative;
      min-height: 107.5px;
      padding-right: 5px;
      margin-right: 10px;
    }
    &.dragging-element,
    &.selected-elements {
      min-height: 107.5px;
    }
    &.empty-elements {
      padding-bottom: 0;
    }

    .list-group {
      padding: 0 0 10px;
    }
  }

  .edition-element {
    right: 0;
    top: -3px;
  }
}
</style>
